import { IOrg, IOrgOptions, IOrgWithLocations } from "./org-models";

export class OrgService {
  public factory(): IOrg {
    return {
      id: 0,
      name: "",
      logo: "",
      stripeUser: {
        id: 0,
        name: "",
        showPaymentCode: false,
      },
      options: this.factoryOrgOptions(),
      status: "",
    };
  }

  public factoryOrgOptions(): IOrgOptions {
    return {
      tAndCUsers: [],
    };
  }

  public factoryOrgWithLocations(): IOrgWithLocations {
    return {
      ...this.factory(),
      locations: {},
    };
  }
}
